// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__103ut","titleText":"styles_titleText__356Zl","nameText":"styles_nameText__3bBeP","avatar":"styles_avatar__3oVu_"};